<div (finMutationObserver)="onDomChange($event)" #target></div>
<ng-container *ngIf="chatButtonState$ | async as helpButtonStatus">
  <fin-pre-chat
    *ngIf="helpButtonStatus === HelpButtonStatus.CLICKED"
    (chatToggle)="chatTrigger($event)"
    (startChat)="startChat()"
    [usePreChatForm]="agentforceLocaleAllowed"
  />

  <button
    *ngIf="helpButtonStatus === HelpButtonStatus.VISIBLE"
    id="chat-help-button"
    (click)="chatTrigger(HelpButtonStatus.CLICKED)"
    class="fixed flex flex--center nordic-blue-900-bg white-text ps-small-x ps-xsmall-y bold-type font-body-1 align-left rounded-left-large"
    [class.dirty]="dirty$ | async"
    tabindex="0"
    [attr.aria-label]="'chat.defaultMinimizedText' | finLocalization"
  >
    <fcom-icon
      class="flex--nogrow icon-medium white-text"
      [dataTestId]="'icon-' + SvgLibraryIcon.CHAT"
      [name]="SvgLibraryIcon.CHAT"
      role="presentation"
    />
    <span class="dn-tablet-down ms-xsmall-l">{{ 'chat.defaultMinimizedText' | finLocalization }}</span>
  </button>

  <div
    *ngIf="helpButtonStatus === HelpButtonStatus.CHAT"
    id="chat-help-loading"
    class="fixed flex flex--center nordic-blue-900-bg white-text ps-small-x ps-xsmall-y bold-type font-body-1 align-left rounded-left-large"
  >
    <fcom-loader [loaderType]="LoaderTheme.BUTTON" [color]="LoaderColor.WHITE" />
  </div>
  @if (renderAudioElement) {
    <audio id="agentforce-chat-notification" class="is-vishidden">
      <source src="https://cdn.finnair.com/chat/Notify.mp3" type="audio/mpeg" />
    </audio>
  }
</ng-container>
